import React, { useEffect, useState } from 'react';
import api from '~/services/api';
import { Label, Input, Select } from '~/componentes/CustomForm';

import { Container } from './styles';
import CustomScrollBar from '~/componentes/CustomScrollBar';
import { Materialize } from '~/styles/materializeGrid';
import { SLModalFooter } from '~/pages/Sistema/componentes/SistemaList';
import ShowConfirmacao from '~/utils/ShowConfirmacao';

function CreateEditContent({ mountedData }) {
  const [responsaveis, setResponsaveis] = useState([]);
  const [ativo, setAtivo] = useState(
    !mountedData ? 'true' : mountedData?.ativo ? 'true' : 'false',
  );

  async function handleSubmit(data, options) {
    const { closeReload } = options || {};

    return ShowConfirmacao(
      async () => {
        let thisData = {
          ...data,
          ...(mountedData?.id ? { id: mountedData?.id } : {}),
          ativo: ativo === 'true' ? true : false,
          responsaveis,
          tipo: 'PRO',
        };
        let response;
        if (mountedData?.id)
          response = await api.put(
            '/signed/empresa/gestorprojeto/etapa/etapa',
            thisData,
          );
        else
          response = await api.post(
            '/signed/empresa/gestorprojeto/etapa/etapa',
            thisData,
          );

        if (response?.status === 200) {
          closeReload && closeReload();
        }
        return response;
      },
      {
        errorModal: {
          defaultMessage: `Ocorreu um erro ao ${
            mountedData?.id ? 'atualizar' : 'cadastrar'
          } essa Etapa, por favor, tente novamente mais tarde.`,
        },
        message: `Tem certeza que deseja ${
          mountedData?.id ? 'atualizar' : 'cadastrar'
        } essa Etapa?`,
        successModal: `Etapa ${
          mountedData?.id ? 'atualizada' : 'cadastrada'
        } com sucesso!`,
      },
    );
  }

  return (
    <Container onSubmit={handleSubmit}>
      <CustomScrollBar fixScrollMargin autoHeightMax="75vh">
        <Materialize className="padding-form">
          <div className="row header">
            <p className="h-descricao">
              Preencha as informações corretamente, e se atente ao (*) pois são
              campos obrigatórios
            </p>
          </div>
          <div className="row">
            <Label title="Código *" className="col s1 m1 l1">
              <Input name="titulo" defaultValue={mountedData?.titulo} />
            </Label>
            <Label title="Título *" className="col s3 m3 l3">
              <Input name="titulo" defaultValue={mountedData?.titulo} />
            </Label>
            <Label title="Data de Abertura *" className="col s2 m2 l2">
              <Input name="data" defaultValue={mountedData?.posicao} />
            </Label>
            <Label title="Valor Fixo *" className="col s2 m2 l2">
              <Select
                isString
                list={{
                  list: [
                    { id: 'S', titulo: 'Sim' },
                    { id: 'N', titulo: 'Não' },
                  ],
                  value: 'id',
                  label: 'titulo',
                }}
                name="final"
                defaultValue={mountedData?.final}
              />
            </Label>
            <Label title="Tempo em Horas *" className="col s2 m2 l2">
              <Input name="tempo" defaultValue={mountedData?.posicao} />
            </Label>
            <Label title="Valor P/ Hora " className="col s2 m2 l2">
              <Input name="valor" defaultValue={mountedData?.posicao} />
            </Label>
          </div>
          <div className="row">
            <Label title="Resp. Projeto *" className="col s3 m3 l3">
              <Select
                isString
                list={{
                  list: [
                    { id: 'S', titulo: 'Sim' },
                    { id: 'N', titulo: 'Não' },
                  ],
                  value: 'id',
                  label: 'titulo',
                }}
                name="final"
                defaultValue={mountedData?.final}
              />
            </Label>
            <Label title="Cliente *" className="col s3 m3 l3">
              <Select
                isString
                list={{
                  list: [
                    { id: 'S', titulo: 'Sim' },
                    { id: 'N', titulo: 'Não' },
                  ],
                  value: 'id',
                  label: 'titulo',
                }}
                name="final"
                defaultValue={mountedData?.final}
              />
            </Label>
            <Label title="Valor Total *" className="col s2 m2 l2">
              <Input name="valortotal" defaultValue={mountedData?.posicao} />
            </Label>
            <Label title="Data do Projeto *" className="col s2 m2 l2">
              <Input name="dataprojeto" defaultValue={mountedData?.posicao} />
            </Label>
            <Label title="E-mail Cliente" className="col s2 m2 l2">
              <Input name="email" defaultValue={mountedData?.posicao} />
            </Label>
          </div>
        </Materialize>
      </CustomScrollBar>
    </Container>
  );
}

export default CreateEditContent;
